import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../style/Loader.css';

const Loader = () => {
    const [statusText, setStatusText] = useState('CONNECTING...');
    const [fillPercentage, setFillPercentage] = useState(0);
    const [isFading, setIsFading] = useState(false);
    const [isVisible, setIsVisible] = useState(true);

    const [displayTitle, setDisplayTitle] = useState('LOADING');

    useEffect(() => {
        const fetchAndSyncData = async () => {
            const STORAGE_KEY = 'site_static_data';

            // 1. Load from cache instantly
            const cachedData = localStorage.getItem(STORAGE_KEY);
            let currentData = null;

            if (cachedData) {
                currentData = JSON.parse(cachedData);
                setDisplayTitle(currentData.name || 'PUBLISHER');
                setFillPercentage(30);
                setStatusText('VERIFYING CACHE...');
            } else {
                setFillPercentage(10);
                setStatusText('CONNECTING SERVER...');
            }

            try {
                // 2. Real API call only
                const response = await axios.post(
                    'https://publisher.cashbolt.in.net/server/',
                    { action: 'getWebVitals' }
                );

                const serverData = {
                    logo: response.data.logo || 'https://publisher.cashbolt.in.net/logo.png',
                    name: response.data.name || 'CashBolt Media',
                    tagline: response.data.tagline || 'Join the elite network'
                };

                // 3. Compare cache vs server
                const hasChanged = !currentData ||
                    serverData.name !== currentData.name ||
                    serverData.logo !== currentData.logo ||
                    serverData.tagline !== currentData.tagline;

                if (hasChanged) {
                    localStorage.setItem(STORAGE_KEY, JSON.stringify(serverData));
                    setDisplayTitle(serverData.name);
                    setStatusText('UPDATING ASSETS...');
                } else {
                    setStatusText('DATA SYNCED...');
                }

                setFillPercentage(100);
                setStatusText('ACCESS GRANTED');

                // 4. Exit animation + self destroy
                setTimeout(() => {
                    setIsFading(true);
                    setTimeout(() => {
                        setIsVisible(false);
                    }, 800);
                }, 600);

            } catch (error) {
                console.error('Loader Fetch Error', error);

                if (currentData) {
                    setFillPercentage(100);
                    setIsFading(true);
                    setTimeout(() => setIsVisible(false), 800);
                } else {
                    setStatusText('CONNECTION FAILED');
                }
            }
        };

        fetchAndSyncData();
    }, []);

    if (!isVisible) return null;

    return (
        <div className={`loader-container-unique ${isFading ? 'loader-fade-out' : ''}`}>
            <div className="loader-content-center-unique">
                <div className="loader-title-wrapper-unique">
                    <span className="loader-title-ghost-unique">
                        {displayTitle}
                    </span>

                    <span
                        className="loader-title-fill-unique"
                        style={{ width: `${fillPercentage}%` }}
                    >
                        {displayTitle}
                    </span>
                </div>

                <p className="loader-status-text-unique">
                    {statusText}
                </p>
            </div>
        </div>
    );
};

export default Loader;
